import type { FinancialMarket } from "api/companyExchange/models/FinancialMarket";
import { shallowEqual } from "react-redux";
import { useSelector } from "react-redux";
import type { RootState } from "state/rootReducer";

export const useFinancialMarket = (): FinancialMarket[] => {
  return useSelector((state: RootState) => state.financialMarket.financialMarket, shallowEqual);
};
